import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-ticket-detail',
  name: '团购详情',
  icon: '详',
  group: '门票详情',
  description: '票种“团购详情”富文本内容区。',
  defaultProps: {
    title: '团购详情',
    html: ''
  }
}
